import { RouterProvider } from "react-router-dom"
import { router } from "./routes/index.jsx";
import { AuthProvider } from "./context-state/AuthContext.jsx";
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from "@vercel/speed-insights/react";
import { APP_ENV } from "@/config-global.jsx";
import { Toaster } from '@/components/ui/sonner.jsx'
import { useNewVersionPolling } from '@/hooks/useNewVersionPolling.jsx'
import { NewVersionMessage } from '@/components/new-version/NewVersionMessage.jsx'

function App() {

  const newVersionAvailable = useNewVersionPolling()

  return (
      <div className="app h-screen w-full font-geist">
          <AuthProvider>
              {
                  APP_ENV !== 'local' ? <><Analytics /><SpeedInsights /></> : null
              }
              <RouterProvider router={router} />
              <Toaster />
          </AuthProvider>
            {
                newVersionAvailable ? <NewVersionMessage /> : null
            }
      </div>

  )
}

export default App
